// Optional label for this device or the person using it ("Gate 2", "Ravi"), sent with every scan.
const KEY = 'scannerName';
export const SCANNER_NAME_MAX = 60;

export function getScannerName() {
  try {
    return (localStorage.getItem(KEY) || '').trim();
  } catch (_) {
    return '';
  }
}

export function setScannerName(name) {
  const value = String(name || '').trim().slice(0, SCANNER_NAME_MAX);
  try {
    if (value) localStorage.setItem(KEY, value);
    else localStorage.removeItem(KEY);
  } catch (_) { /* storage unavailable */ }
  return value;
}
